import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=ca7a48cc&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=ca7a48cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7a48cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca7a48cc')) {
      api.createRecord('ca7a48cc', component.options)
    } else {
      api.reload('ca7a48cc', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=ca7a48cc&scoped=true&", function () {
      api.rerender('ca7a48cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tt0K076N0Toz/JS/comp/PopupDialog.vue"
export default component.exports